import { render, staticRenderFns } from "./AccessEditModal.vue?vue&type=template&id=4fe9a8fe&"
import script from "./AccessEditModal.vue?vue&type=script&lang=js&"
export * from "./AccessEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports